/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Required_ProvinceInputs */

const vi_validation_required_province = /** @type {(inputs: Validation_Required_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn tỉnh / thành phố`)
};

/**

* @param {Validation_Required_ProvinceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_required_province = /** @type {((inputs?: Validation_Required_ProvinceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Required_ProvinceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_required_province(inputs)
});